<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;">
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">Vídeos de Ajuda</v-toolbar-title>
                    <v-spacer/>
                    <v-text-field
                        dense
                        clearable
                        outlined
                        single-line
                        hide-details
                        v-model="search"
                        label="Pesquise.."
                        append-icon="mdi-magnify"
                    />
                    <v-spacer/>
                    <v-btn color="grey darken-1" outlined small class="mr-2" @click="managerVisible = true">
                        <v-icon left small>mdi-shape-outline</v-icon>
                        Categorias
                    </v-btn>
                    <v-btn color="primary" fab small @click="openCadastro">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card elevation="2" class="ma-1">
                    <v-card-text>
                        <v-data-table
                            fixed-header
                            :headers="headers"
                            :items="dados"
                            :mobileBreakpoint="0"
                            :loading="loading"
                            :height="$vuetify.breakpoint.height - 180"
                            @click:row="editar"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                            :search="search"
                        >
                            <template v-slot:item.imagem="{ item }">
                                <img
                                    :src="getThumbUrl(item)"
                                    style="width: 64px; height: 36px; object-fit: cover; border-radius: 6px; display: block;"
                                    alt="capa"
                                    @error="onThumbError"
                                />
                            </template>

                            <template v-slot:item.categoria="{ item }">
                                <v-chip v-if="item.categoria" small color="blue lighten-5" text-color="blue darken-2">
                                    {{ item.categoria.nome }}
                                </v-chip>
                                <span v-else class="grey--text">—</span>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <v-chip
                                    small
                                    :color="item.status === 'ativo' ? 'green lighten-4' : 'grey lighten-2'"
                                    :text-color="item.status === 'ativo' ? 'green darken-2' : 'grey darken-1'"
                                >
                                    {{ item.status === 'ativo' ? 'Ativo' : 'Inativo' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                            </template>

                            <template v-slot:item.acoes="{ item }">
                                <v-btn icon color="error" @click.stop="excluir(item)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <VideoAjuda
                    :visible="visible"
                    :formData="form"
                    :categorias="categorias"
                    @onCadastro="onCadastro"
                    @close="close"
                />
                <CategoriasManager
                    :visible="managerVisible"
                    @changed="onCategoriasChanged"
                    @close="managerVisible = false"
                />
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import VideoAjuda from './VideoAjuda';
import CategoriasManager from './CategoriasManager';

export default {
    name: 'VideosAjuda',

    components: {
        BaseContainer,
        VideoAjuda,
        CategoriasManager,
    },

    data: () => ({
        search: '',
        visible: false,
        managerVisible: false,
        loading: false,
        dados: [],
        categorias: [],
        form: {},
        headers: [
            { text: 'ID',        value: 'id',         width: '60px' },
            { text: 'Capa',      value: 'imagem',     width: '90px', sortable: false },
            { text: 'Título',    value: 'title' },
            { text: 'Categoria', value: 'categoria',  width: '160px' },
            { text: 'Ordem',     value: 'ordem',      width: '90px' },
            { text: 'Status',    value: 'status',     width: '110px' },
            { text: 'Data/Hora', value: 'created_at', width: '160px' },
            { text: '',          value: 'acoes',      width: '70px', sortable: false, align: 'center' },
        ],
    }),

    mounted() {
        this.consultar();
        this.consultarCategorias();
    },

    methods: {
        consultar() {
            if (!this.checkPermission('zapercontrol_videos_ajuda_consultar')) {
                alert('Usuário sem permissão');
                return;
            }

            this.loading = true;
            this.dados = [];

            this.$http.get('videos-de-ajuda/listar').then(resp => {
                this.dados = resp.data.data;
                this.loading = false;
            })
            .catch(() => {
                alert('Não foi possivel concluir a operação', 'warning');
            }).finally(() => (this.loading = false));
        },

        consultarCategorias() {
            this.$http.get('categorias-video-ajuda').then(resp => {
                this.categorias = resp.data;
            }).catch(() => {});
        },

        onCategoriasChanged() {
            this.consultarCategorias();
            this.consultar();
        },

        close() {
            this.visible = false;
            this.form = {};
        },

        openCadastro() {
            if (!this.checkPermission('zapercontrol_videos_ajuda_adicionar')) {
                alert('Usuário sem permissão');
                return;
            }

            const proximaOrdem = this.dados.length
                ? Math.max(...this.dados.map(v => Number(v.ordem) || 0)) + 1
                : 1;

            this.form = { status: 'ativo', ordem: proximaOrdem };
            this.visible = true;
        },

        onCadastro() {
            this.close();
            this.consultar();
        },

        editar(row) {
            if (!this.checkPermission('zapercontrol_videos_ajuda_atualizar')) {
                alert('Usuário sem permissão');
                return;
            }

            this.form = row;
            this.visible = true;
        },

        async excluir(item) {
            if (!this.checkPermission('zapercontrol_videos_ajuda_excluir')) {
                alert('Usuário sem permissão');
                return;
            }

            const ok = await this.$root.$confirm(
                'Excluir vídeo',
                `Deseja realmente excluir "${item.title}"?`,
                { color: 'red darken-1' }
            );
            if (!ok) return;

            this.$http.delete(`videos-de-ajuda/${item.id}`).then(() => {
                this.notify('Vídeo excluído com sucesso!');
                this.consultar();
            }).catch(() => {
                alert('Não foi possivel excluir o vídeo');
            });
        },

        getThumbUrl(item) {
            if (item.imagem && item.imagem.path) {
                return `${this.$urlAPI}/videos-de-ajuda/files/${item.imagem.path}`;
            }
            const id = this.youtubeId(item.url);
            return id
                ? `https://img.youtube.com/vi/${id}/mqdefault.jpg`
                : '';
        },

        youtubeId(url) {
            if (!url) return '';
            const match = url.match(/(?:embed\/|v=|youtu\.be\/|shorts\/)([A-Za-z0-9_-]{6,})/);
            return match ? match[1] : '';
        },

        onThumbError(e) {
            e.target.style.visibility = 'hidden';
        },
    },
}
</script>
